import { BadgeSkeleton } from "@circleco/compass/components/BadgeSkeleton";
import { Skeleton } from "@circleco/compass/components/Skeleton";
import { TypographySkeleton } from "@circleco/compass/components/TypographySkeleton";

const AVATAR_SIZE = "size-[84px]";
const META_ROW_WIDTHS = ["w-36", "w-44", "w-16"];
const PROFILE_FIELD_LABEL_WIDTHS = ["w-24", "w-20", "w-28"];

export const RailProfile = () => (
  <div className="flex w-full flex-col" data-testid="rail-profile-loader">
    <div className="relative flex flex-col items-start gap-6 border-b border-primary px-6 pb-6 pt-8">
      <Skeleton shape="rounded" className={AVATAR_SIZE} />
      <div className="flex w-full min-w-0 flex-col gap-3">
        <div className="flex min-w-0 flex-col gap-1">
          <TypographySkeleton variant="heading-md" className="w-40" />
          <TypographySkeleton variant="body-sm" className="w-52" />
        </div>
        <div className="flex flex-col items-start gap-2">
          {META_ROW_WIDTHS.map(width => (
            <div key={width} className="flex items-center gap-1">
              <Skeleton shape="rounded" className="size-4" />
              <TypographySkeleton variant="label-xs" className={width} />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        <BadgeSkeleton className="w-10" />
        <BadgeSkeleton className="w-16" />
      </div>
    </div>
    <div className="flex flex-col gap-6 px-6 pt-6">
      <TypographySkeleton variant="label-md" className="w-16" />
      <div className="flex flex-col gap-2">
        <Skeleton shape="pill" className="h-6 w-28" />
        <TypographySkeleton variant="label-xs" className="w-44" />
      </div>
      <div className="flex flex-col gap-2">
        <TypographySkeleton variant="label-sm" className="w-24" />
        <TypographySkeleton variant="body-sm" lines={2} />
      </div>
      <div className="flex flex-col gap-2">
        <TypographySkeleton variant="label-sm" className="w-20" />
        <div className="flex items-center gap-2">
          <Skeleton shape="rounded" className="size-4" />
          <TypographySkeleton variant="body-sm" className="w-52" />
        </div>
      </div>
      {PROFILE_FIELD_LABEL_WIDTHS.map(width => (
        <div key={width} className="flex flex-col gap-2">
          <TypographySkeleton variant="label-sm" className={width} />
          <TypographySkeleton variant="body-sm" className="w-32" />
        </div>
      ))}
    </div>
  </div>
);
